import { Box } from "@mui/material";
import { ICompany } from "Models/Company";
import { useIntl } from "react-intl";

export interface ICompanyStatusProps {
  company: ICompany;
}

export const CompanyStatus = ({company}: ICompanyStatusProps) => {
  const { formatMessage } = useIntl();
  const desactivatedDate = company.deactivatedAt ? new Date(company.deactivatedAt) : null;
  const now = new Date();
  
  
  if (!desactivatedDate ) {  
    return <Box sx={{display: 'flex', alignItems: 'center'}}><Box sx={{
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      backgroundColor: "#27939D",
      marginRight: '8px',
      fontSize: '0.9rem'
    }}/>{formatMessage({ id: "companyStatus.activeCompany" })}</Box>
  }
  if (desactivatedDate > now) {  
    return <Box sx={{display: 'flex', alignItems: 'center'}}><Box sx={{
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      backgroundColor: "#F19229",
      marginRight: '8px',
      fontSize: '0.9rem'
    }}/>{formatMessage({ id: "companyStatus.inDeactivationPeriod" })}</Box>
  }
  return <Box sx={{display: 'flex', alignItems: 'center'}}><Box sx={{
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    backgroundColor: "#8D004C",
    marginRight: '8px'
  }}/>{formatMessage({ id: "companyStatus.deactivatedCompany" })}</Box>
}
